import type { AddNewCommentPayload } from '@domain/schemas/payload.schema';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { CreateCommentResponse } from '@responses/comments';
import axios from 'axios';

import { queryClient } from '../utils/queryClient';

export const createComment = async (
  data: AddNewCommentPayload,
  submissionId: string,
): Promise<CreateCommentResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'post',
    url: `submissions/${submissionId}/comments`,
    data,
  });

  const response = await axios(networkPayload);
  await queryClient.invalidateQueries({ queryKey: ['submissions'] });
  await queryClient.invalidateQueries({ queryKey: ['search'] });
  return response.data;
};
